export const Dash = "\u2014";

/**
 * Money Out keeps the sign that was entered. Money In saves the opposite sign,
 * so an entered negative becomes positive and an entered positive becomes negative.
 */
export function signedAmount(amount: number, isMoneyIn: boolean): number {
  return isMoneyIn ? -amount : amount;
}

export function isValidDate(d: any): boolean {
  if (Object.prototype.toString.call(d) === "[object Date]") {
    if (isNaN(d.getTime())) {
      return false;
    }
    return true;
  }
  return false;
}

export function isMileageAccount(
  glAccountId: string | undefined,
  account: string | undefined
): boolean {
  return (
    glAccountId !== "transfers" &&
    (account === "Non-Sourcing Mileage/Transportation" ||
      glAccountId === "non-sourcing-mileage-transportation" ||
      account === "Sourcing Mileage/Transportation" ||
      glAccountId === "sourcing-mileage-transportation")
  );
}

export function getMileageDescription(description?: string): string {
  if (!description) return "";
  const re = new RegExp(`(.*?) ${Dash} (\\d+(\\.\\d*)?) miles`);
  const match = description.match(re);
  if (match) return match[1];
  return description;
}
